import React from 'react';
import ListFile from './listFile';

// La liste porte ses propres fiches : cet enrobage n'ajoutait qu'une grille.
function Files() {
  return <ListFile />;
}

export default Files;
